<div class="agpr-curatedInfoSection">
    <agpr-message [severity]="messageSeverityEnum.info">
        <span class="agpr-briefing-mentionCount-highlight">{{ mentionCount }}</span>
        <span>{{ 'Briefings.addCoverage.mentionsAdded' | localize }}</span>
    </agpr-message>

    <div class="agpr-curatedInfoSection-toGoSort">
        <agpr-button
            [id]="id + '.goToSortTool'"
            label="Briefings.sortTool.goTo"
            [style]="buttonTypes.tertiary"
            (click)="goToSortTool()"
        ></agpr-button>
    </div>
</div>